export const BILLING_SCHEDULE_EVENT_ENUM = {
  PaymentDueDate: 'PaymentDueDate',
  LateFeeAssessment: 'LateFeeAssessment',
  BillSubmissionDeadline: 'BillSubmissionDeadline',
  ResidentStatementIssue: 'ResidentStatementIssue',
  Autopay: 'Autopay'
};
export const BILLING_SCHEDULE_EVENT_ENUM_TO_TITLE = {
  PaymentDueDate: {
    title: 'shared_keys.payment_due_date',
    hintBody: 'shared_keys.payment_due_date_hint'
  },
  LateFeeAssessment: {
    title: 'shared_keys.late_fee_assessed',
    hintBody: 'shared_keys.late_fee_assessed_hint'
  },
  BillSubmissionDeadline: {
    title: 'shared_keys.bill_submission_deadline',
    hintBody: 'shared_keys.bill_submission_deadline_hint'
  },
  ResidentStatementIssue: {
    title: 'shared_keys.statements_issued',
    hintBody: 'shared_keys.statements_issued_hint'
  },
  Autopay: {
    title: 'shared_keys.autopay_runs',
    hintBody: 'shared_keys.autopay_runs_hint'
  }
};